import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { luxuryproImageUrl, luxuryproImageUrlFallback } from './luxuryproImageUrl';

export default function LuxuryProCatalogThumb({ src, alt = '', sx = {} }) {
  const [imgSrc, setImgSrc] = useState('');
  const [step, setStep] = useState(0);

  useEffect(() => {
    setStep(0);
    setImgSrc(src ? luxuryproImageUrl(src, 200) : '');
  }, [src]);

  if (!src) {
    return (
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 1,
          bgcolor: '#f0f0f0',
          flexShrink: 0,
          ...sx,
        }}
      />
    );
  }

  if (!imgSrc && step >= 2) {
    return (
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 1,
          bgcolor: '#f5f5f5',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 9,
          color: '#999',
          ...sx,
        }}
      >
        N/A
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={imgSrc}
      alt={alt}
      referrerPolicy="no-referrer"
      onError={() => {
        if (step === 0) {
          const fb = luxuryproImageUrlFallback(src, 200);
          if (fb && fb !== imgSrc) {
            setStep(1);
            setImgSrc(fb);
            return;
          }
        }
        if (step <= 1) {
          const idMatch = String(src).match(/googleusercontent\.com\/d\/([^/?]+)/i);
          if (idMatch) {
            setStep(2);
            setImgSrc(`https://drive.google.com/uc?export=view&id=${encodeURIComponent(idMatch[1])}`);
            return;
          }
        }
        setStep(3);
        setImgSrc('');
      }}
      sx={{
        width: 48,
        height: 48,
        objectFit: 'cover',
        borderRadius: 1,
        flexShrink: 0,
        border: '1px solid #e0e0e0',
        bgcolor: '#fafafa',
        ...sx,
      }}
    />
  );
}
